export default "__VITE_ASSET__DeRwycZ6__"